<template>
  <div class="dashboard-sidebar-content-section-ui">
    <slot />
  </div>
</template>
